module.exports = __webpack_public_path__ + "img/ic_32_date.787a6bda.svg";